import { CommonModule } from '@angular/common';
import { ChatService } from '../../services/chat.service';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { MESSAGE_UNREAD_TEXT } from '../../utils/constants';

@Component({
  selector: 'app-dynamic-buttons',
  templateUrl: './dynamic-buttons.component.html',
  styleUrls: ['./dynamic-buttons.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MessageTimestampComponent,
  ],
})
export class DynamicButtonsComponent implements OnInit {
  @Input() input: any;
  @Input() lastMessage!: boolean;
  @Input() isRead: boolean = false;
  @Input() canSendMessage: boolean = true;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  config: any;
  messageText: string = '';
  messageUnreadText: string = MESSAGE_UNREAD_TEXT;

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;
  }

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  onButtonClick(button: any) {
    if (!this.config.active) {
      return;
    } else {
      button.config.forEach((conf: any) => {
        if (conf.type === 'URL Link') {
          window.open(conf.link_url, conf.new_tab ? '_blank' : '_self');
        }
      });

      const flavour = this.chatService.configs?.script.flavour;

      if (flavour && flavour > 0) {
        this.lastMessage = false;
        this.action.emit({
          type: 'Response',
          button_id: `${button.id}`,
          message_text: button.label,
          option: button,
          label: button.label,
        });
      }
    }
  }
}
